import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { GlobalOffersMessages } from '../../interfaces/cart-details.interface';
import { hiddenElementSlideInOut } from '../animations/slides.animation';
import MessagesActionsService from '../services/messages-actions.service';


@Component({
  selector: 'message-component',
  templateUrl: './slot-message.component.html',
  animations: [hiddenElementSlideInOut],
})
export default class SlotMessageComponent implements OnInit {
  @Input() messages: GlobalOffersMessages;
  @Input() slotNumber: number;
  @Input() isOwner: boolean;
  @Input() isNewSlotSection: boolean;

  @ViewChild('warningBox') warningBox: ElementRef;

  public dataAutomationId: string;
  public elementVisible = true;

  constructor(
    private elementRef: ElementRef,
    private messagesActionsService: MessagesActionsService,
  ) {}

  ngOnInit(): void {
    this.dataAutomationId = this.isOwner ? 'multi-owner-info' : 'multi-member-info';

    this.elementRef.nativeElement
      .closest('.layer-shadowed')
      .classList.add('layer-with-warning');
  }

  public removeMessage(): void {
    this.messagesActionsService.deleteMessage(this.messages.uid);

    this.hideMessage();
  }

  private hideMessage(): void {
    const bannerWrapper = this.warningBox.nativeElement;
    this.elementVisible = false;

    bannerWrapper
      .closest('.layer-shadowed')
      .classList.remove('layer-with-warning');
  }
}
